import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  DataLayerCreateModalContainer, type DataLayerCreateModalProps,
} from './dataLayerCreateModal.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    DataLayerCreate: DataLayerCreateModalProps;
  }
}

modalRenderer.register('DataLayerCreate', DataLayerCreateModalContainer);
